<template>
  <v-container fluid>
    <v-dialog v-model="formDialogStatus" max-width="800px">
      <formDialog
        :dialogStatus.sync="formDialogStatus"
        :editedData="editedItem"
        :indexEdited.sync="editedIndex"
      ></formDialog>
    </v-dialog>
    <v-dialog v-model="deleteDialogStatus" max-width="600px">
      <deleteDialog
        v-on:changeTitle="updateTitleData($event)"
        v-on:changeStat="closeDelDialog($event)"
      ></deleteDialog>
    </v-dialog>
       
    <div>
    	
    
      <v-container fluid style="width: 100%">
        <v-layout wrap>
          <v-flex xs2 sm2 md2>
            <navDrawer />
          </v-flex>
          <v-flex xs10 sm10 md10>
           <v-card-title>
        

           <v-expansion-panels
      v-model="panel"
      :disabled="disabled"
      multiple
    >
           <v-expansion-panel>
        <v-expansion-panel-header>Search E-content Data</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-layout wrap xs12>
          <v-flex xs4 sm4 md4 xs4>
            <v-text-field
                class="mt-3 ml-2 mr-2"
                v-model="searchParam.author_name"
                label="Author Name">
            </v-text-field>
          </v-flex>
          <v-flex xs4 sm4 md4 xs4>
            <v-text-field
                class="mt-3 ml-2 mr-2"
                v-model="searchParam.document_title"
                label="Document Title">
            </v-text-field>
          </v-flex>
          <v-flex xs4 sm4 md4 xs4>
            <v-text-field
                class="mt-3 ml-2 mr-2"
                v-model="searchParam.language"
                label="Language">
            </v-text-field>
          </v-flex>
          <v-flex xs4 sm4 md4 xs4>
            <v-text-field
                class="mt-3 ml-2 mr-2"
                v-model="searchParam.subject"
                label="Subject">
            </v-text-field>
          </v-flex>
           <v-flex xs4 sm4 md4 xs4>
            <v-text-field
                class="mt-3 ml-2 mr-2"
                v-model="searchParam.tag"
                label="Tag">
            </v-text-field>
          </v-flex>
           
            <!-- <p>Content Type</p> -->
            <v-select
                      class="mt-3 ml-2 mr-2"
                      item-text="name"
                      item-value="id"
                      v-model="searchParam.content_type_id"
                      :items="contentType"
                      
                      
             ></v-select>
         
          
        </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
     </v-expansion-panels>
          
          
            
          <!--   <v-btn  color="red" @click.native="clearFilteredData">
              cancel
            </v-btn> -->
        

        
       
       
      </v-card-title>
      <div align="center">
     <v-btn color="primary" @click="searchEContent">
              search
            </v-btn>
          </div>
      <br><br>
            <v-card color="white">
              <v-layout row>
                <!-- {{getTitle}} -->
                <v-card flat>
                  <v-card-text class="title"><b>E-Content List </b></v-card-text>
                </v-card>
                <v-divider class="my-2" vertical></v-divider>

                <v-spacer />
                <v-card flat>
                  <v-card-actions>
                    <v-spacer />

                    <v-btn color="primary" dark @click="newItem"
                      >Create New E-Content </v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-layout>
            </v-card>
            <v-data-table
              :headers="headers"
              :items="getEContentItem"
              
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  fab
                  small
                  color="primary"
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon small color="red" @click="deleteDialogOpen(item)">
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" > Reset </v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import formDialog from "@/components/eContent/eContentForm.vue";
import deleteDialog from "@/components/utils/deleteDialog.vue";
import navDrawer from "@/layouts/navDrawer.vue";
export default {
  components: {
    formDialog,
    navDrawer,
    deleteDialog
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        rowsPerPageItems: [10, 25, { text: "All", value: -1 }],
      },
      panel: [0, 1],
      disabled: false,
      readonly: false,
      editedItem:{},
      editedIndex: -1,
      loading: false,
      title : "tiiii",
      dialog: false,
      formDialogStatus: false,
      deleteDialogStatus:false,
      deleteId:{},
      searchParam: {},
      contentType:[
         {
          id:1,
          name:"pdf"
         },
         {
          id:2,
          name:"audio"
         },
         {
          id:3,
          name:"video"
         },
      ],
      headers: [
     
        { text: "Document Title", value: "document_title", sortable: false },
        { text: "Author Name", value: "author_name", sortable: false },
        // { text: "Publisher Name", value: "publisher_name", sortable: false },
        // { text: "content_urle", value: "content_url", sortable: false },
        { text: "Content type Id", value: "content_type_id", sortable: false },
        { text: "Language", value: "language", sortable: false },
        { text: "Subject", value: "subject", sortable: false },
        
        
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedIndex: -1,

      exam_name: "",
      exam_year: "",
      ex_code: "",
    };
  },
  created() {
    this.$store.dispatch("callEContentData");
  },
  computed: {
    getEContentItem() {
      return this.$store.getters.getEContentItem;
    },
    getLoggedInStatus() {
      return this.$store.getters.getLoggedIn;
    },
    getTitle(){
      return this.title;
    }
  },
  watch: {
    getTitle(val){
    
      if(val == "confirmed"){
        this.deleteItem();
      }
    },
    pagination() {
      // this.getDataFromApi();
    },
  },
  methods: {
      searchEContent() {
     //  console.log("searchEContent");
      
      this.$store
        .dispatch("searchEContentList", this.searchParam)
        .then((data) => {
        });
    },
    dialogOpen() {
      this.formDialogStatus = true;
    },
    closeDelDialog(deleteDialogStatus){
        this.deleteDialogStatus = false;
      },
     updateTitleData(title){
        this.title = title;
      },
    newItem() {
      
      this.dialogOpen();
    },
     editItem(item) {
      this.editedIndex = this.getEContentItem.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogOpen();
    },
     deleteDialogOpen(item){
      this.deleteId = item.id;
      this.deleteDialogStatus = true;
     },
     deleteItem() {
      // const id = item.id;
      let self = this;
        
        this.$store
        .dispatch("deleteEContentItem", this.deleteId)
        .then(function(data) {
       
          try {
            self.deleteDialogStatus = false;
            self.$store.dispatch("callEContentData");
            
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function(error) {
         //  console.log(error);
          
        });
   
       
      
    }
  },
};
</script>
<style>
.mycustomExpansionPanel .v-expansion-panel__header {
  border: 1px solid blue !important;
}
</style>
